<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <div class="vx-row">
            <div class="vx-col w-1/5 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.term')" rules="required|max:1" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.term") }}*</label>
                <vs-input type="number" v-model="form.term" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/5 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.year')" rules="required|length:4" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.year") }}*</label>
                <vs-input type="number" minlength="4" maxlength="4" v-model="form.year" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/5 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.name')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.name") }}*</label>
                <vs-input type="text" v-model="formName" class="w-full" disabled />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/5 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.nameTh')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.nameTh") }}*</label>
                <vs-input type="text" v-model="formNameTh" class="w-full" disabled />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/5 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.status')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.status") }}*</label>
                <v-select v-model="form.status" :clearable="false" :options="statusesOptions" name="status" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="submit">{{ $t("sections.master.dataForm.action.btnSave") }}</vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset">{{ $t("sections.master.dataForm.action.btnReset") }}</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers, mapGetters } from 'vuex'

const {mapActions: mapMasterActions, mapState: mapMasterFields } = createNamespacedHelpers('Master')

export default {
  components: {
    vSelect,
    ValidationProvider
  },

  data () {
    return {
      form:{
        term: 0,
        year: 0,
        name: '',
        status: 'Enabled'
      }
    }
  },
  async created () {
    const vm = this
    await vm.getPeriod({form: {id: vm.$route.params.id}})
    vm.pms ('MasterPeriod', 'edit', 'r')

    vm.form = {
      term: vm.period.term,
      year: vm.period.year,
      name: vm.period.name,
      status: vm.period.status
    }
  },
  computed: {
    ...mapMasterFields(['status', 'period']),
    ...mapGetters({
      statusesOptions :'Master/statusesOptions'
    }),
    formName: function() {
      const convName = this.form.term+"/"+this.form.year
      return convName
    },
    formNameTh: function() {
      const convName = `${this.form.term}/${parseInt(this.form.year)+543}`
      return convName
    }
  },
  methods: {
    ...mapMasterActions(['getPeriod', 'updatePeriod']),
    async submit () {
      const vm = this
      vm.$refs['form'].validate().then(success => {
        if (!success) {
          return
        }

        this.updatePeriod({
          id: vm.$route.params.id,
          form: {
            term: parseInt(vm.form.term),
            year: parseInt(vm.form.year),
            name: this.formName,
            nameTh: this.formNameTh,
            status: vm.form.status.value || vm.form.status
          },
          vm,
          redirect: "/master/period"
        })
      })
    },
    reset () {
      const vm = this
      vm.form = {
        term: vm.period.term,
        year: vm.period.year,
        name: vm.period.name,
        status: vm.period.status
      }
    }
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
}
</script>
